import { ToastContainer } from "react-toastify";

import useNotificationStore from "../store/notification.store";

import { NotificationDialog } from "./NotificationDialog";
import { NotificationConfirm } from "./NotificationConfirm";

export default function NotificationContainer() {
  const dialog = useNotificationStore((state) => state.dialog);
  const closeDialog = useNotificationStore((state) => state.closeDialog);
  const confirm = useNotificationStore((state) => state.confirm);

  return (
    <div>
      <ToastContainer />

      {dialog && <NotificationDialog visible={true} onHide={() => closeDialog()} {...dialog} />}

      {confirm && <NotificationConfirm {...confirm} />}
    </div>
  );
}
